import { useAppSelector } from "@next-platform/client-common-core";

/**
 * Whether the reader is known to be logged out, read from the same store fields the route guards use.
 * Pages with nothing to show a guest render nothing for them and open the sign in overlay instead.
 */
export default function useIsLoggedOutReader(): boolean {
  return useAppSelector((state) => state.userInfo.isAuthLoaded && !state.userInfo.isAuthenticated);
}
